/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import moment from 'moment'
import { Box } from '@mui/material'
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined'
import { colors } from '@resiliatech/birdsong'
import { DatePicker } from '../../../../../SharedComponents/DatePicker/DatePicker'
import {
  ISO_8601_DATE_FORMAT,
  TASK_DATE_FORMAT,
} from '../../../ImpactReportDashboard/utils'
import { OnUpdateOptions } from '../types'
import { dateInputStyles } from './TaskModalV2.styled'

type StartDateInputProps = {
  onUpdateOptions: OnUpdateOptions
  startDate: string | null | undefined
}

export const StartDateInput = ({
  onUpdateOptions,
  startDate,
}: StartDateInputProps) => (
  <Box sx={{ flex: '1' }}>
    <DatePicker
      props={{ slots: { openPickerIcon: InsertInvitationOutlinedIcon } }}
      slotProps={{
        openPickerIcon: { sx: { color: colors.interactive.primaryEnabled } },
      }}
      clearable={false}
      date={moment
        .utc(startDate, ISO_8601_DATE_FORMAT)
        .format(TASK_DATE_FORMAT)}
      label='Starting*'
      onDateSelected={(date) =>
        onUpdateOptions({
          key: 'startDate',
          value: date ? moment.utc(date).format(TASK_DATE_FORMAT) : null,
        })
      }
      styles={dateInputStyles}
    />
  </Box>
)
